import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import type { UseXtdhTokensListStateParams, XtdhTokensListState } from "../types";
export function useXtdhTokensListState(params) {
  const $ = _c(6);
  const {
    tokens,
    isEnabled,
    isLoading,
    isError
  } = params;
  const tokenCount = tokens.length;
  const hasTokens = tokenCount > 0;
  const showInitialLoading = isLoading && !hasTokens;
  const showInitialError = isError && !hasTokens;
  const showEmptyState = !showInitialLoading && !showInitialError && !hasTokens;
  const t0 = !isEnabled;
  let t1;
  if ($[0] !== hasTokens || $[1] !== showEmptyState || $[2] !== showInitialError || $[3] !== showInitialLoading || $[4] !== t0) {
    t1 = {
      isDisabled: t0,
      showInitialLoading,
      showInitialError,
      showEmptyState,
      hasTokens
    };
    $[0] = hasTokens;
    $[1] = showEmptyState;
    $[2] = showInitialError;
    $[3] = showInitialLoading;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}